<div class="top-bar-nav">
  <div class="container">
    <nav class="navbar navbar-expand-md">
      <div class="navbar-collapse">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item advertising-info">
            <app-block identifier="top_menu_left_side_advertising_block"></app-block>
          </li>
        </ul>
        <div class="navbar-nav top-bar-right">
          <app-top-bar-menu></app-top-bar-menu>

          <app-store-switcher></app-store-switcher>

          <app-currency-dropdown></app-currency-dropdown>
        </div>
      </div>
    </nav>
  </div>
</div>
